/** 16:9 slide page size for PDF export (millimetres). */
export const SURF_PDF_PAGE_WIDTH_MM = 297;
export const SURF_PDF_PAGE_HEIGHT_MM = (SURF_PDF_PAGE_WIDTH_MM * 9) / 16;
export const SURF_PDF_PAGE_SIZE = [SURF_PDF_PAGE_WIDTH_MM, SURF_PDF_PAGE_HEIGHT_MM];
export function normRectToPdfMm(rect) {
    return {
        x: rect.x * SURF_PDF_PAGE_WIDTH_MM,
        y: rect.y * SURF_PDF_PAGE_HEIGHT_MM,
        w: rect.w * SURF_PDF_PAGE_WIDTH_MM,
        h: rect.h * SURF_PDF_PAGE_HEIGHT_MM,
    };
}
/** Font size in points from relative text role size (matches editor proportion). */
export function pdfFontSizePt(sizeRel) {
    return pdfFontSizePtForSlideHeight(sizeRel, SURF_PDF_PAGE_HEIGHT_MM);
}
/** Font size in points when the slide is drawn into a rectangle of given height (mm). */
export function pdfFontSizePtForSlideHeight(sizeRel, slideHeightMm) {
    const slideHeightPt = (slideHeightMm / 25.4) * 72;
    const minPt = Math.max(4, (slideHeightMm / SURF_PDF_PAGE_HEIGHT_MM) * 8);
    return Math.max(minPt, sizeRel * slideHeightPt);
}
/** Slide height in CSS pixels aligned with PDF page (96 dpi). */
export function pdfSlideHeightPx() {
    return (SURF_PDF_PAGE_HEIGHT_MM / 25.4) * 96;
}
export function hexToRgb(hex) {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
    if (!m)
        return [30, 41, 59];
    const n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
/** Map web font to jsPDF built-in fallback when custom VFS not registered. */
export function pdfFontFamily(font) {
    const f = font.toLowerCase();
    if (f.includes("courier") || f.includes("mono"))
        return "courier";
    if (f.includes("georgia") || f.includes("serif"))
        return "times";
    return "helvetica";
}
